import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../utils';
import { ZGetWishlistSuggestions, ZPrizeCore } from './models';

const c = initContract();

const ZGetFavouritedPrizesResponse = ZPrizeCore.extend({
  categories: z.string().array(),
  mainCategories: z.array(z.string()),
  tierCode: z.string(),
  tierValue: z.number().nullable(),
  drawTypePlans: z.string().array(),
}).array();
export type TGetFavouritePrizesResponse = z.infer<
  typeof ZGetFavouritedPrizesResponse
>;

export const authPrizeContract = c.router(
  {
    getFavouritedPrizes: {
      method: 'GET',
      path: '/get-favourited-prizes',
      query: z.object({
        drawSchedule: z.string(),
      }),
      responses: {
        200: ZGetFavouritedPrizesResponse,
        404: z.object({
          message: z.string(),
        }),
      },
      summary: 'Get favourite prizes (wish list) of a player',
    },

    getFavouritedPrizesV2: {
      method: 'GET',
      path: '/get-favourited-prizes-v2',
      query: z.object({
        drawTypeCode: z.string(),
        drawScheduleCode: z.string(),
      }),
      responses: {
        200: ZGetFavouritedPrizesResponse,
        404: z.object({
          message: z.string(),
        }),
      },
      summary: 'Get favourite prizes (wish list) of a player',
    },

    getFavouritedPrizeIds: {
      method: 'GET',
      path: '/get-favourited-prize-ids',
      responses: {
        200: z.number().array(),
        404: z.object({
          message: z.string(),
        }),
      },
      summary: 'Get ids of favourite prizes (wish list) of a player',
    },

    favouritePrize: {
      method: 'POST',
      path: '/favourite-prize',
      body: z.object({
        prizeId: z.coerce.number(),
      }),
      responses: {
        200: successSchema,
      },
      summary: 'Favourite a prize',
    },

    unfavouritePrize: {
      method: 'DELETE',
      path: '/favourite-prize',
      body: z.object({
        prizeId: z.coerce.number(),
      }),
      responses: {
        200: successSchema,
      },
      summary: 'Unfavourite a prize',
    },

    getWishlistSuggestions: {
      method: 'GET',
      path: '/wishlist-suggestions',
      query: z.object({
        limit: z.coerce.number(),
      }),
      responses: {
        200: ZGetWishlistSuggestions,
      },
      summary: 'Get wishlist suggested prizes',
    },
  },
  {
    pathPrefix: '/auth',
    baseHeaders: z.object({
      'x-access-token': z.string(),
    }),
    commonResponses: {
      401: c.type<{ message: 'Unauthorized'; statusCode: 401 }>(),
      // 500: c.otherResponse({
      //   contentType: 'text/plain',
      //   body: z.literal('Server Error'),
      // }),
    },
  },
);
